<template>
  <div>
    <v-card
      outlined
      flat
      :disabled="disabled"
      :class="{ 'border-red': isError }"
      v-bind="$attrs"
    >
      <div ref="editor" :style="{ height: height }"></div>
    </v-card>
    <div v-if="isError" class="errormessage pl-2">
      <span class="red--text">{{ errorMessages[0] }}</span>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'

import Quill from 'quill'

export default {
  name: 'Editor',

  inheritAttrs: false,

  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    label: {
      type: String,
      required: false,
      default: null
    },

    height: {
      type: String,
      required: false,
      default: 'auto'
    },

    errorMessages: {
      type: Array,
      required: false,
      default: null
    }
  },

  data() {
    return {
      editor: null
    }
  },

  computed: {
    isError() {
      return this.errorMessages?.length > 0
    }
  },

  watch: {
    value(value) {
      this.setContent(value)
    },

    disabled(value) {
      this.editor?.enable(!value)
    }
  },

  mounted() {
    this.initEditor()
  },

  methods: {
    initEditor() {
      this.editor = new Quill(this.$refs.editor, {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'strike', 'underline'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link']
            ]
          }
        },
        formats: ['bold', 'italic', 'strike', 'underline', 'list', 'link'],
        theme: 'snow'
      })

      // disabled
      if (this.disabled) {
        this.editor.disable()
      }

      // content
      if (this.value) {
        this.setContent(this.value)
      }

      // listeners
      this.editor.on('text-change', () => {
        const html = this.getContent()
        this.$emit('input', html)
      })
    },

    getContent() {
      const element = this.$refs.editor?.querySelector('.ql-editor')
      if (element) {
        return element.innerHTML
      } else {
        return null
      }
    },

    setContent(html) {
      const element = this.$refs.editor.querySelector('.ql-editor')
      const content = this.getContent()

      if (element && html !== content) {
        element.innerHTML = html
      }
    },

    clear() {
      this.$refs.editor.querySelector('.ql-editor').innerHTML = ''
    },

    insertHTML(html) {
      const selection = this.editor.getSelection(true)
      this.editor.clipboard.dangerouslyPasteHTML(selection.index ?? 0, html)
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.ql-tooltip) {
  z-index: 9999;

  input {
    color: black;
  }
}

.theme--dark {
  :deep(.ql-toolbar) {
    button {
      .ql-stroke {
        fill: none;
        stroke: white;
      }

      .ql-fill {
        fill: white;
        stroke: none;
      }

      .ql-picker {
        color: white;
      }
    }
  }
}

:deep(.ql-toolbar) {
  button:hover,
  button.ql-active {
    .ql-stroke {
      fill: none;
      stroke: var(--v-primary-base);
    }

    .ql-fill {
      fill: var(--v-primary-base);
      stroke: none;
    }

    .ql-picker {
      color: var(--v-primary-base);
    }
  }
}
</style>
